export default __webpack_public_path__ + "static/media/review.efc9326c.svg";